import { render } from "./PopUpModal.vue?vue&type=template&id=70fc30dc&scoped=true&ts=true"
import script from "./PopUpModal.vue?vue&type=script&lang=ts"
export * from "./PopUpModal.vue?vue&type=script&lang=ts"

import "./PopUpModal.vue?vue&type=style&index=0&id=70fc30dc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fc30dc"]])

export default __exports__